import { type PropsWithChildren, type ReactNode } from "react";

import clsx from "clsx";
import { isMacOs } from "react-device-detect";

import { GenericTooltip } from "@components/tooltip-container";

interface Props {
  content: ReactNode;
  shortcut?: string;
  hideShortcut?: boolean;
  showTooltip?: boolean;
}

export const Tooltip = ({
  content,
  shortcut,
  hideShortcut,
  showTooltip,
  children,
}: PropsWithChildren<Props>) => {
  return (
    <GenericTooltip
      showTooltip={showTooltip}
      content={
        content && (
          <div className="flex items-center gap-3">
            {content}
            {!hideShortcut && (
              <div
                className={clsx(
                  "text-xxs border rounded px-1 py-1",
                  "flex items-center border-v2-overlay-shadow-200",
                  { "gap-[1px]": isMacOs },
                )}
              >
                <span className="text-[8px]">
                  {isMacOs ? (
                    <i className="fa-regular fa-command"></i>
                  ) : (
                    "Ctrl+"
                  )}
                </span>
                {shortcut}
              </div>
            )}
          </div>
        )
      }
      noInfoCircle
      placement="right"
      overlayClassName="bg-v2-inverse text-v2-inverse font-semibold rounded-lg pointer-events-none"
    >
      {children}
    </GenericTooltip>
  );
};
